import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";

import { ReactComponent as Check } from "../../assets/icons/benefitCheck.svg";
import { ReactComponent as Warning } from "../../assets/icons/yellowWarning.svg";
import { ReactComponent as NotCheck } from "../../assets/icons/benefitNoCheck.svg";

import { ReactComponent as GrovsLogo } from "../../assets/icons/marketing/grovsLogo.svg";
import { ReactComponent as BranchLogo } from "../../assets/icons/marketing/branchLogo.svg";
import { ReactComponent as AppsFlyerLogo } from "../../assets/icons/marketing/appsFlyerLogo.svg";
import { motion } from "framer-motion";

const GrovsComparationTable = () => {
  const features = [
    {
      title: "Deep Links + Deferred Linking",
      grovs: "Built-in",
      grovsIcon: <Check />,
      branch: "Built-in",
      branchIcon: <Check />,
      appsFlyer: "Built-in",
      appsFlyerIcon: <Check />,
    },
    {
      title: "No-Code Campaign Tools",
      grovs: "Marketer-first",
      grovsIcon: <Check />,
      branch: "Dev heavy setup",
      branchIcon: <Warning />,
      appsFlyer: "Dev heavy setup",
      appsFlyerIcon: <Warning />,
      banchTextStyle: {
        fontWeight: 400,
        color: "rgba(118, 114, 113, 1)",
      },
      appsFlyerTextStyle: {
        fontWeight: 400,
        color: "rgba(118, 114, 113, 1)",
      },
    },
    {
      title: "Smart Messaging + Alerts",
      grovs: "Included",
      grovsIcon: <Check />,
      branch: "Add-ons or missing",
      branchIcon: <NotCheck />,
      appsFlyer: "Add-ons or missing",
      appsFlyerIcon: <NotCheck />,
      banchTextStyle: {
        fontWeight: 400,
        color: "rgba(118, 114, 113, 1)",
      },
      appsFlyerTextStyle: {
        fontWeight: 400,
        color: "rgba(118, 114, 113, 1)",
      },
    },
    {
      title: "Unified ROI Dashboard",
      grovs: "Out-of-the-box",
      grovsIcon: <Check />,
      branch: "Requires extra setup",
      branchIcon: <Warning />,
      appsFlyer: "Requires extra setup",
      appsFlyerIcon: <Warning />,
      banchTextStyle: {
        fontWeight: 400,
        color: "rgba(118, 114, 113, 1)",
      },
      appsFlyerTextStyle: {
        fontWeight: 400,
        color: "rgba(118, 114, 113, 1)",
      },
    },
    {
      title: "Cost to Scale",
      grovs: "60% lower",
      grovsIcon: <Check />,
      branch: "2x more expensive",
      branchIcon: <NotCheck />,
      appsFlyer: "2x more expensive",
      appsFlyerIcon: <NotCheck />,
      banchTextStyle: {
        fontWeight: 700,
        color: "rgb(187, 25, 57)",
      },
      appsFlyerTextStyle: {
        fontWeight: 700,
        color: "rgb(187, 25, 57)",
      },
      grovsTextStyle: {
        fontWeight: 700,
        fontSize: "17px",
        color: "rgb(3, 141, 108)",
      },
    },
  ];

  return (
    <DeliverWrapper>
      <FeatureHeader>
        <FeatureCell>
          <FeatureTitle>Feature</FeatureTitle>
        </FeatureCell>
        <FeatureCell>
          <GrovsLogo />
        </FeatureCell>
        <FeatureCell>
          <BranchLogo />
        </FeatureCell>
        <FeatureCell>
          <AppsFlyerLogo />
        </FeatureCell>
      </FeatureHeader>
      {features.map((item, index) => (
        <DeliverItem key={index}>
          <TitleCell>
            <p>{item.title}</p>
          </TitleCell>
          <CheckCell>
            {item.grovsIcon}
            <p style={item.grovsTextStyle}>{item.grovs}</p>
          </CheckCell>
          <CheckCell>
            {item.branchIcon}
            <p style={item.banchTextStyle}>{item.branch}</p>
          </CheckCell>
          <CheckCell>
            {item.appsFlyerIcon}
            <p style={item.appsFlyerTextStyle}>{item.appsFlyer}</p>
          </CheckCell>
        </DeliverItem>
      ))}
    </DeliverWrapper>
  );
};

export default GrovsComparationTable;

const DeliverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  width: 80%;
  margin: auto;

  @media (max-width: 990px) {
    width: 100%;
  }
`;
const DeliverItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  border-top: 1px solid rgba(237, 235, 234, 1);
  ::first-child {
    border: none;
  }
`;
const TitleCell = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  p {
    color: ${lightThemeColors.darkColor};
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
  }
  @media (max-width: 990px) {
    p {
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
    }
  }
  @media (max-width: 550px) {
    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
    }
  }
`;
const CheckCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  svg {
    min-height: 28px;
    max-height: 28px;
    min-width: 28px;
    max-width: 28px;
  }
  p {
    color: ${lightThemeColors.darkColor};
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
  }
  @media (max-width: 990px) {
    svg {
      min-height: 18px;
      max-height: 18px;
      min-width: 18px;
      max-width: 18px;
    }
    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
  }

  @media (max-width: 550px) {
    flex-direction: column;
    p {
      font-size: 14px;
      text-align: center;
    }
  }
`;
const FeatureHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
  height: 100%;
`;
const FeatureCell = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  width: 100%;
  height: 100%;

  @media (max-width: 550px) {
    justify-content: center;
    svg {
      max-width: 60px;
    }
  }
`;
const FeatureTitle = styled.p`
  color: ${lightThemeColors.darkColor};
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  @media (max-width: 550px) {
    font-size: 20px;
    line-height: 24px;
  }
`;
